<template>
    <div class="form-group w-100">
        <div class="input-group">
            <input type="text" class="form-control"
                   v-model="new_value">
            <span class="input-group-addon pointer" title="Відміна">
                <i class="fa fa-ban yellow" @click="reset_value"></i>
            </span>
            <span class="input-group-addon pointer" title="Застосувати" @click="change">
                <i class="fa fa-spinner green" v-if="load"></i>
                <i class="fa fa-check green" v-else></i>
            </span>
        </div>
    </div>

</template>

<script>
export default {
    name: "Editable",
    props: {
        id: '',
        target:'',
        value: '',
    },
    data() {
        return {
            new_value: '',
            load:false,
        }
    },
    created() {
        this.new_value = this.value
    },
    methods: {
        reset_value() {
            this.new_value = this.value
        },
        change() {
            this.load = true;
            axios
                .post('/editable',{
                    id:this.id,
                    target:this.target,
                    value:this.new_value,
                })
                .then(response => {
                    window.location.reload();
                })
                .catch(error => {
                    console.error(error)
                })
        },
    }
}
</script>

<style scoped>
.green {
    color: green;
}

.yellow {
    color: red;
}

.pointer {
    cursor: pointer;
}
</style>
